// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Accordion__Provider$PrezzeeRibbon from "./Accordion__Provider.bs.js";

function fillFn(bgColour, textColour, hoverColour) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.backgroundColor(bgColour),
              BsCssJs$PrezzeeRibbon.color(textColour),
              BsCssJs$PrezzeeRibbon.transition(Theme__Animation$PrezzeeRibbon.slow, undefined, "easeOut", "background-color"),
              BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.backgroundColor(hoverColour)])
            ]);
}

function shadow(shadow_) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.boxShadow(shadow_ ? Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.zero, BsCssJs$PrezzeeRibbon.px(10), BsCssJs$PrezzeeRibbon.px(30), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(14, 18, 27, BsCssJs$PrezzeeRibbon.pct(10))) : "none")]);
}

function themeStyling(colour, theme) {
  if (typeof colour !== "number") {
    return fillFn(colour._0, colour._1, colour._2);
  }
  switch (colour) {
    case /* White */2 :
        return fillFn(Theme__Color$PrezzeeRibbon.white, Theme__Color$PrezzeeRibbon.gray800, Theme__Color$PrezzeeRibbon.gray50);
    case /* Red */0 :
    case /* Charcoal */1 :
    case /* BusinessPurple */3 :
    case /* BusinessCharcoal */4 :
    case /* Primary */5 :
        break;
    case /* Secondary */6 :
        return fillFn(theme.secondary.default, theme.secondary.defaultText, theme.secondary.hover);
    case /* Tertiary */7 :
        return fillFn(theme.tertiary.default, theme.tertiary.defaultText, theme.tertiary.hover);
    
  }
  return fillFn(theme.primary.default, theme.primary.defaultText, theme.primary.hover);
}

function wrapper(theme) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.overflow("hidden"),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius)
            ]);
}

var Styles = {
  fillFn: fillFn,
  shadow: shadow,
  themeStyling: themeStyling,
  wrapper: wrapper
};

function Accordion(props) {
  var shadow$1 = props.shadow;
  var colour = props.colour;
  var expanded = props.expanded;
  var disabled = props.disabled;
  var onChange = props.onChange;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var disabled$1 = disabled !== undefined ? disabled : false;
  var expanded$1 = expanded !== undefined ? expanded : false;
  var colour$1 = colour !== undefined ? colour : /* Primary */5;
  var shadow$2 = shadow$1 !== undefined ? shadow$1 : /* Nothing */0;
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  var themeStyling$1 = themeStyling(colour$1, theme);
  return JsxRuntime.jsx(Accordion__Provider$PrezzeeRibbon.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: Classnames([
                          wrapper(theme),
                          shadow(shadow$2),
                          themeStyling$1,
                          className$1
                        ])
                  }),
              onChange: onChange$1,
              expanded: expanded$1,
              disabled: disabled$1
            });
}

var Provider;

var Heading;

var Trigger;

var Panel;

var make = Accordion;

export {
  Styles ,
  Provider ,
  Heading ,
  Trigger ,
  Panel ,
  make ,
}
/* classnames Not a pure module */
